<template>
  <div class="card" data-qa="company-card" @click="clickFullRow">
    <div class="header">
      <div class="title">
        <h4>{{ company.Name }}</h4>
      </div>
    </div>

    <address itemscope itemtype="http://schema.org/Organization">
      <div itemprop="address">
        <span v-if="company.Address" itemprop="streetAddress">{{ company.Address }}</span>
        <template v-if="showMore">
          <br />
          <span v-if="company.ZipCode" itemprop="postal-code">
            {{ company.ZipCode }}
          </span>
        </template>
        <template v-else>, </template>
        <span v-if="company.City" itemprop="locality">{{ company.City }}</span>
        <br />
      </div>

      <template v-if="company.Email && showMore">
        {{ i18n.t('/LeaseCompany/Details/Email') }}
        <span itemprop="email" data-qa="company-email">{{ company.Email }}</span
        ><br />
      </template>

      <template v-if="company.DebtorId && showMore">
        {{ i18n.t('/LeaseCompany/Details/DebtorId') }}
        <span data-qa="company-debtorid">{{ company.DebtorId }}</span
        ><br />
      </template>

      <template v-if="company.CrmNumber && showMore">
        {{ i18n.t('/LeaseCompany/Details/CrmNumber') }}
        <span data-qa="company-magic-number">{{ company.CrmNumber }}</span
        ><br />
      </template>

      <template v-if="company.CustomerId && showMore">
        {{ i18n.t('/LeaseCompany/Details/CustomerId') }}
        <span data-qa="company-magic-number">{{ company.CustomerId }}</span
        ><br />
      </template>
    </address>

    <div class="buttons">
      <app-button
        button-class="inverted--bordered btn-toggle-details"
        data-qa="toggle-company-details-button"
        @click.prevent.stop="showMore = !showMore"
      >
        {{
          i18n.t(
            showMore ? '/LeaseCompany/Search/ShowLessInfo' : '/LeaseCompany/Search/ShowMoreInfo'
          )
        }}
      </app-button>
      <app-button
        button-class="primary"
        data-qa="choose-company-button"
        @click.stop="selectCompany"
      >
        {{ i18n.t('/LeaseCompany/Search/SelectLeaseCompany') }}
      </app-button>
    </div>
  </div>
</template>

<script>
import AppButton from '@/components/generic/presentational/atoms/appButton/AppButton.vue'

export default {
  components: {
    AppButton,
  },
  props: {
    company: {
      type: Object,
      required: true,
    },
  },
  emits: ['selectResult'],
  data() {
    return {
      i18n: window.VUE_CLI_EXPORTS.plugins.i18n,
      showMore: false,
    }
  },

  computed: {},
  methods: {
    selectCompany() {
      this.$emit('selectResult', this.company)
    },
    clickFullRow(event) {
      this.selectCompany()
    },
  },
}
</script>

<style lang="scss" scoped>
.card {
  border: 1px solid $gray-light;
  margin-bottom: $gutter;
  padding: $gutter;
  transition: background-color 0.2s ease-out;
  cursor: pointer;

  &:hover {
    background: #f8f8f8;
  }
}

.header {
  margin-bottom: 0.5em;

  @include breakpoint(md) {
    display: flex;
    align-items: flex-start;
  }
}

.title {
  margin-right: 0.5em;

  h4 {
    display: inline;
  }
}

.info-label {
  flex: 0 0 auto;
  background: $gray-lightest;
  margin-bottom: 1em;
  padding: 0.25em 0.5em;
  display: inline-flex;
  align-items: center;
  max-width: 100%;

  @include breakpoint(md) {
    display: flex;
    margin: 0 0 0 auto;
  }
}

.icon-info-label {
  @include icon();

  margin-right: 0.25em;
}

address {
  margin-bottom: 1em;
}

.buttons {
  display: flex;
  justify-content: space-between;
}

.btn-toggle-details {
  color: inherit;
}
</style>
